function init() {

    // wrap the final word in the upper left heading
    var h3Element = document.getElementById('footerTopLeft');
    // Check if the <h3> element exists
    if (h3Element) {
        // Get the text content of the <h3> element
        var text = h3Element.textContent.trim();

        // Split the text into an array of words
        var words = text.split(' ');

        // Check if there are multiple words
        if (words.length > 1) {
            // Remove the last word from the array
            var lastWord = words.pop();

            // Reconstruct the text with the last word wrapped in a <span>
            h3Element.innerHTML = words.join(' ') + ' <span>' + lastWord + '</span>';
        }
    }

    // add 72px of padding to last child in entry content to make up for negative footer top margin
    // Select the <div> with class 'entry-content'
    var entryContentElement = document.querySelector('.entry-content');

    // Check if the element exists and has direct children
    if (entryContentElement && entryContentElement.children.length > 0) {
        // Get the last direct child of the 'entry-content' div
        var lastChild = entryContentElement.lastElementChild;

        // Get the current padding-bottom of the last child from inline style (if any)
        var currentPaddingBottom = lastChild.style.paddingBottom;

        if (!currentPaddingBottom) {
            // If no inline padding is set, get the computed style
            currentPaddingBottom = window.getComputedStyle(lastChild).paddingBottom;
        }
        
        // Convert the padding value to a number (remove 'px' from the string)
        currentPaddingBottom = parseFloat(currentPaddingBottom);

        // Add 72px to the current padding
        var newPaddingBottom = currentPaddingBottom + 72;

        // Apply the new padding-bottom value to the last child
        lastChild.style.paddingBottom = newPaddingBottom + 'px';
    }

    // footer easter egg - image setup
    window.addEventListener('load', function () {
        var imageFirst = document.querySelector('footer .image-first');
        var imageSecond = document.querySelector('footer .image-second');
      
        // Only run if both images exist
        if (imageFirst && imageSecond) {
      
          function adjustSecondImageHeight() {
            var firstImageHeight = imageFirst.clientHeight;
            imageSecond.style.height = firstImageHeight + 'px';
          }
      
          // Adjust heights when the page loads
          adjustSecondImageHeight();
      
          // Listen for window resize events if the height is responsive
          window.addEventListener('resize', adjustSecondImageHeight);
        }
    });
    // swap images when #letsgorva is clicked
    // Check if the element "footer .image-second" exists
    if (document.querySelector('footer .image-second')) {
        // Get the element with ID "letsGoRva"
        const letsGoRva = document.getElementById('letsGoRva');
    
        // Check if the element with ID "letsGoRva" exists
        if (letsGoRva) {
        // Add a click event listener to "letsGoRva"
        letsGoRva.addEventListener('click', function() {
            // Find all images inside the element with the class "o-footer__main-left__logo"
            const logoImages = document.querySelectorAll('.o-footer__main-left__logo > img');
            
            // Loop through each image and toggle the "logo-shown" class
            logoImages.forEach(function(img) {
            img.classList.toggle('logo-shown');
            });
        });
        }
    }
  
  
      
      

}

export { init as default }